import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';
import { typographyFontSizeCfg, typographyLineHeightCfg } from 'ds/components/typography/types';

export const Wrapper = styled.div``;

export const Header = styled(Text)<{ isOpen?: boolean; isFirst: boolean }>`
  justify-content: flex-start;
  ${({ theme, isOpen }) => `
    transition: all .2s ease;
    color: ${isOpen ? theme.colors.brand.light : theme.colors.neutrals.grey1};
    display: flex;
    cursor: pointer;
    svg {
      transition: all .3s ease;
      transform: rotate(${isOpen ? 0 : 90}deg);
      margin-left: ${theme.spacing(1)};
      path {
        fill: ${isOpen ? theme.colors.brand.light : theme.colors.neutrals.grey1};
      }
    }
    ${isOpen ? `
      span {
        color: ${theme.colors.brand.light};
      }
    ` : ''}
  `}

  ${({ theme, isFirst }) => theme.media.showAt({ at: 1 })`
    padding: ${theme.spacing(3)} 0;
    margin-top: ${isFirst ? theme.spacing(2) : '0'};
  `}

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    font-size: ${typographyFontSizeCfg.h2.mobile}px;
    line-height: ${typographyLineHeightCfg.h2.mobile}px;
    padding: ${theme.spacing(2)} 0;
  `}
`;

export const ArrowIconWrapper = styled.div`
  display: flex;
  align-items: center;
  transition: all .3s ease;
`;

export const Content = styled.div`
  ${({ theme }) => `
    margin-bottom: ${theme.spacing(2)};
  `}
`;
